import { type FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppStoreProvider } from './store/appStore';
import { useAppLifecycle } from './App.hooks';
import { StyleViewerPage } from './pages/StyleViewerPage';

const AppInner: FC = () => {
  useAppLifecycle();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StyleViewerPage />} />
        <Route path="*" element={<StyleViewerPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export const App: FC = () => {
  return (
    <AppStoreProvider>
      <AppInner />
    </AppStoreProvider>
  );
};
